<template>
  <div class="pu_tovar_size">
    <div class="pu_tovar_size_title">
      {{category.name}}
      <i v-if="category.data.is_required"><img :src="require('@/assets/img/facebook/inf_ico.svg')"></i>
      <span v-if="showRule" class="pu_rule_msg">{{ ruleMessage }}</span>
    </div>

    <div class="pu_tl_head_info">
      <span v-if="isNeeded">{{ text('product_options_necessary') }}</span>
      <span v-if="inRule">{{ getSelectedRuleMessage(category) }}</span>
    </div>

    <ul class="pu_tovar_size_list">

      <li v-for="(modifier, index) in getModifiers(category)"
          @click.prevent="pick('radio', modifier)"
          :class="{'act': isPicked('radio', modifier)}"
          :key="'cat_' + category.id + '_mod_' + index"
      >
        {{modifier.name}}
        <span v-if="modifier.weight && $store.getters.currentProduct.qty_unit">{{modifier.weight}} </span>
        <!--                <span v-if="!modifier.categoryNew.show_absolute_price">-->
        <!--                    <template v-if="modifier.display_price < 0">-</template>-->
        <!--                    <template v-else>+</template>-->
        <!--                    {{ modifier.display_price | toCurrency | replace('-', '') }}-->
        <!--                </span>-->
        <!--                <span v-else>{{ modifier.display_price | toCurrency }}</span>-->
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'RadioBubbleModifiers',
    props: {
      category: Object,
      showRule: Boolean,
      isNeeded: Boolean,
      inRule: Boolean,
      selectedRuleMessage: String,
      ruleMessage: String,

      isPicked: Function,
      pick: Function,
      getModifierCount: Function
    },
    methods: {

      getModifiers(category) {
        let result = []
        this.$store.getters.currentProduct.modifiers.forEach(element => {
          if (element.category_id === category.id) {
            result.push(element)
          }
        })

        return result
      }
    }
  }
</script>

<style scoped>
  .pu_tovar_size_title {
    font-size: 14px;
    font-weight: 500;
    color: #999999;
  }


  .pu_tovar_size_list {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: 15px;
    margin-left: -10px;
    margin-bottom: -10px;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .pu_tovar_size_list > li {
    margin-left: 10px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 16px;
    color: #000000;
    height: 33px;
    line-height: 33px;
    border: 1px solid #999999;
    padding-left: 13px;
    padding-right: 13px;
    background: transparent;
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
    -webkit-border-radius: 50px;
    border-radius: 50px;
  }

  .pu_tovar_size_list > li span {
    color: #999999;
    display: inline-block;
    margin-left: 7px;
  }

  .pu_tovar_size_list > li.act {
    background: #0084FF;
    border-color: #0084FF;
    color: #FFF;
  }

  .pu_tovar_size_list > li.act span {
    color: #FFF;
    opacity: 0.5;
  }

  .pu_rule_msg {
    display: block;
    font-size: 12px;
  }

</style>
